<div class="statusBarWrapper" [class.alignLeft]="trackingItemStatus === null">
    @if (statusType === DistributionStatusBarTypeEnum.BAR && trackingItemStatus === TrackingItemStatusEnum.COMPLETED) {
        <div class="progress-bar">
            <div class="progress-bar-fill" [ngStyle]="{ 'width.%': displayValue }"></div>
        </div>
        <span>{{ displayValue }}%</span>
    } @else {
        <ng-container *ngTemplateOutlet="icon"></ng-container>
    }
</div>

<ng-template #icon>
    @if (trackingItemStatus !== null) {
        <ng-container *ngTemplateOutlet="trackingItemStatusTemplate"></ng-container>
    } @else {
        @if (customTooltipMessage) {
            <div appTooltip trigger="hover" [componentData]="customTooltipMessage" position="top" [showDelay]="200" [hideDelay]="200">
                <ng-container *ngTemplateOutlet="channelMonitoringStatusTemplate"></ng-container>
            </div>
        } @else {
            <ng-container *ngTemplateOutlet="channelMonitoringStatusTemplate"></ng-container>
        }
    }
</ng-template>

<ng-template #completedValues>
    @if (displayValue) {
        <div class="statusWrapper true">
            <i class="fas true fa-check"></i>
        </div>
    } @else {
        <div class="statusWrapper false" title="{{ tooltip }}">
            <i class="fas false fa-xmark"></i>
        </div>
    }
</ng-template>

<ng-template #trackingItemStatusTemplate>
    @switch (trackingItemStatus) {
        @case (TrackingItemStatusEnum.COMPLETED) {
            @if (customTooltipMessage) {
                <div appTooltip trigger="hover" [componentData]="customTooltipMessage" position="top" [showDelay]="200" [hideDelay]="200">
                    <ng-container *ngTemplateOutlet="completedValues"></ng-container>
                </div>
            } @else {
                <ng-container *ngTemplateOutlet="completedValues"></ng-container>
            }
        }
        @case (TrackingItemStatusEnum.RUNNING) {
            <div class="statusWrapper running" title="Running">
                <i class="fas true fa-loader"></i>
            </div>
        }
        @case (TrackingItemStatusEnum.PENDING) {
            <div class="statusWrapper pending" title="Pending">
                <i class="fas true fa-spinner"></i>
            </div>
        }
        @case (TrackingItemStatusEnum.UNKNOWN) {
            <div appTooltip trigger="hover" componentData="Status Unknown" position="top" [showDelay]="200" [hideDelay]="200">
                <div class="statusWrapper pending">
                    <i class="fa fa-question"></i>
                </div>
            </div>
        }
        @default {
            <span>{{ displayValue.toString() | translate }}</span>
        }
    }
</ng-template>

<ng-template #channelMonitoringStatusTemplate>
    @switch (channelMonitoringStatus) {
        @case (ChannelMonitoringStatusEnum.SUCCESS) {
            <div class="statusWrapper true">
                <i class="fas true fa-check"></i>
            </div>
        }
        @case (ChannelMonitoringStatusEnum.FAILURE) {
            <div class="statusWrapper false">
                <i class="fas false fa-xmark"></i>
            </div>
        }
        @case (ChannelMonitoringStatusEnum.SCHEDULED) {
            <div class="statusWrapper pending">
                <i class="far fa-calendar-plus"></i>
            </div>
        }
        @case (ChannelMonitoringStatusEnum.CREATED) {
            <div class="statusWrapper pending">
                <i class="far fa-calendar-plus"></i>
            </div>
        }
        @case (ChannelMonitoringStatusEnum.UNKNOWN) {
            <div class="statusWrapper pending">
                <i class="fa fa-question"></i>
            </div>
        }
        @default {
            <span>{{ displayValue.toString() | translate }}</span>
        }
    }
</ng-template>
